module.exports = __webpack_public_path__ + "img/5-4.b8a8915e.svg";